import { ExternalLink, X } from "lucide-react";
import { useState } from "react";

export default function ConsumerSiteBanner() {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-8 right-8 z-50">
      <div
        className="bg-black/80 backdrop-blur-sm border-2 border-white p-4 shadow-lg max-w-xs"
        style={{ fontFamily: "'Courier New', monospace" }}
      >
        {/* Close button */}
        <button
          onClick={() => setIsVisible(false)}
          className="absolute top-2 right-2 p-1 hover:bg-white/10 transition-colors"
          aria-label="Close"
        >
          <X className="w-4 h-4 text-white" />
        </button>

        {/* Content */}
        <div className="pr-6">
          <p className="text-white text-sm mb-3">Visit Our Consumer Site</p>

          <a
            href="https://thecontentgroup.co"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-4 py-2 bg-white text-black text-xs font-bold uppercase tracking-wide border-2 border-white hover:bg-transparent hover:text-white transition-all"
          >
            Click Here
            <ExternalLink className="w-3 h-3" />
          </a>
        </div>
      </div>
    </div>
  );
}
